import { render, staticRenderFns } from "./SetBidValidityWidget.vue?vue&type=template&id=8e0f1620&"
import script from "./SetBidValidityWidget.vue?vue&type=script&lang=js&"
export * from "./SetBidValidityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports